import React from "react";

export type IconName = "arrow" | "map-marker" | "briefcase" | "clear" | "check" | "menu";

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
}

const SvgIcon: React.FC<SvgIconProps> = ({ name, ...props }) => {
  switch (name) {
    case "arrow": {
      return (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M10.9492 25.0078L35.9492 25.0078" stroke="currentColor" strokeWidth="2" />
          <path
            d="M23.9706 38.0079L37 24.9785L23.9706 11.9491"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      );
    }
    case "map-marker": {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M12 22.5207C11.7891 22.2862 11.5394 22.0052 11.261 21.6856C9.99403 20.2317 8.14957 18.0003 6.62753 15.7055C5.86631 14.5578 5.19921 13.4142 4.72553 12.3589C4.24464 11.2875 4 10.387 4 9.7027C4 5.48001 7.54979 2 12 2C16.4502 2 20 5.48001 20 9.7027C20 10.387 19.7554 11.2875 19.2745 12.3589C18.8008 13.4142 18.1337 14.5578 17.3725 15.7055C15.8504 18.0003 14.006 20.2317 12.739 21.6856C12.4606 22.0052 12.2109 22.2862 12 22.5207Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <circle cx="12" cy="10" r="2" fill="currentColor" />
        </svg>
      );
    }
    case "briefcase": {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 8H22V22H2V8ZM4 10V20H20V10H4Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 6C6 4.34315 7.34315 3 9 3H15C16.6569 3 18 4.34315 18 6V9H16V6C16 5.44772 15.5523 5 15 5H9C8.44772 5 8 5.44772 8 6V9H6V6Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case "clear": {
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5186 15.3046L15.3037 3.51953L16.4822 4.69804L4.69711 16.4832L3.5186 15.3046Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.69731 3.51957L16.4824 15.3047L15.3039 16.4832L3.5188 4.69809L4.69731 3.51957Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case "check": {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2072 6.70718L10.0001 17.9143L4.29297 12.2072L5.70718 10.793L10.0001 15.0859L19.793 5.29297L21.2072 6.70718Z"
            fill="currentColor"
          />
        </svg>
      );
    }
    case "menu": {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect x="2" y="4" width="2" height="2" fill="currentColor" />
          <rect x="7" y="4" width="15" height="2" fill="currentColor" />
          <rect x="2" y="18" width="2" height="2" fill="currentColor" />
          <rect x="7" y="18" width="15" height="2" fill="currentColor" />
          <rect x="2" y="11" width="2" height="2" fill="currentColor" />
          <rect x="7" y="11" width="15" height="2" fill="currentColor" />
        </svg>
      );
    }
    default: {
      return null;
    }
  }
};

export default SvgIcon;
